import { Component, Host, Prop, h } from '@stencil/core';
export class LoadingIndicatorComponent {
  constructor() {
    /**
     * Size of Loading Indicator
     * `"medium"` will be applied when size is not specified
     */
    this.size = 'md';
    /**
     * Type of Loading Indicator
     * `"default"` will be applied when type is not specified
     */
    this.type = 'default';
    /**
     * Provide screen reader users with additional context or to convey information not available in HTML alone
     */
    this.srContext = 'loading...';
  }
  /**
   * Create HTML representation of component DOM and return this
   for output to the browser DOM
   */
  render() {
    const { size, type, srContext } = this;
    return (h(Host, null,
      h("span", { "aria-hidden": "true", class: {
          ['loading-indicator']: true,
          [`loading-indicator--${size}`]: true,
          [`loading-indicator--${type}`]: true
        } }),
      srContext ? h("span", { class: "sr-only" }, srContext) : ''));
  }
  static get is() { return "agl-ds-loading-indicator"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["loading-indicator.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["loading-indicator.component.css"]
  }; }
  static get properties() { return {
    "size": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "LoadingIndicatorSize",
        "resolved": "\"lg\" | \"md\" | \"sm\"",
        "references": {
          "LoadingIndicatorSize": {
            "location": "import",
            "path": "./loading-indicator.types"
          }
        }
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": "Size of Loading Indicator\n`\"medium\"` will be applied when size is not specified"
      },
      "attribute": "size",
      "reflect": false,
      "defaultValue": "'md'"
    },
    "type": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "LoadingIndicatorType",
        "resolved": "\"default\" | \"inverse\" | \"muted\"",
        "references": {
          "LoadingIndicatorType": {
            "location": "import",
            "path": "./loading-indicator.types"
          }
        }
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": "Type of Loading Indicator\n`\"default\"` will be applied when type is not specified"
      },
      "attribute": "type",
      "reflect": false,
      "defaultValue": "'default'"
    },
    "srContext": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": "Provide screen reader users with additional context or to convey information not available in HTML alone"
      },
      "attribute": "sr-context",
      "reflect": false,
      "defaultValue": "'loading...'"
    }
  }; }
}
